<template>
  <span class="messages-counter" v-show="state.count > 0">
    {{ state.count > 999 ? "···" : state.count }}
  </span>
</template>

<script setup lang="ts">
  import { onMounted, reactive } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";

  const auctionStore = useAuctionStore();

  const props = withDefaults(
    defineProps<{
      initCount?: number;
    }>(),
    {
      initCount: 0
    }
  );

  const state = reactive({
    count: props.initCount || 0
  });

  onMounted(async () => {
    if (auctionStore.user?.id) {
      window.Echo.private(`chat.${auctionStore.user.id}.message.count`).listen(
        ".chat.to_user.message.count",
        (e: { unreadCount: number }) => {
          state.count = e.unreadCount;
        }
      );
    }
  });
</script>
